import React from 'react';

export default function FormSectionHeading(props) {
    return <h6 className="tw-text-base tw-text-charcoal tw-font-semibold tw-capitalize">{props.heading}</h6>;
}
